<template>
    <div v-if="iconName" class="svg-icon">
        <svg :width="size" :height="size" :style="{ fill: iconColor }" class="custom-icon">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="iconId" />
        </svg>
    </div>
</template>
<script>
/**
 * https://ionicons.com/
 * https://www.iconfont.cn/search/index
 * https://icomoon.io/
 * http://fontello.com/
 *
 */
export default {
    name: 'Icon',
    props: {
        iconName: { type: String, default: 'box' },
        size: { type: [Number, String], default: 32 },
        iconColor: { type: String, default: 'currentColor' }
    },
    computed: {
        iconId() {
            return `#icon-${this.iconName}`
        }
    }
}
</script>

<style scoped>
div.svg-icon {
    display: inline-block;
    cursor: pointer;
    text-align: center;
}
.custom-icon{
    vertical-align: middle;
    fill: currentColor;
    overflow: hidden;
    width: 100%;
    height: 100%;
}
</style>

